import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_5: FaireProductEntity = {
  token: "legacy_prod_abbott-5",
  type: "product",
  name: "Green LED Pillar Candle 4x8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/585c02694096c1bb0243bea7e24c283b2ab93eeb70dd3b767bd473ca00a52583.jpeg",
  priceDollars: 12,
  msrpDollars: 24,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
